.container {
  display: inline-flex;
  align-items: baseline;
  justify-content: space-between;
}

.description {
  margin-left: 8px;
}
